<template>
  <main>
    <!-- Filtri: categoria e ricerca -->
    <v-flex v-if="showFilters" xs12 d-flex class="accent pa-1 elevation-1">
      <v-flex class="title line-height-36 white--text pl-2">{{ title }}</v-flex>
      <v-flex xs4 class="mr-2">
        <categorie-prodotti-select :label="$t('magazzino.label.categorie_tutte')" v-model="internalCategory"
                                   :show-dismessi="showDismessi"
                                   :clearable="!disableClearableCategory" solo-inverted flat dark class="input--dense"/>
      </v-flex>
      <v-flex xs5>
        <text-field :label="`${$t('azioni.cerca')}...`" v-model="search"
                    solo-inverted flat dark prepend-inner-icon="search" class="input--dense"/>
      </v-flex>
    </v-flex>

    <!-- Tabella -->
    <data-table :headers="headers" :items="filteredProdotti"
                :loading="loading" :search="search"
                :rows-per-page="rowsPerPage"
                initial-sort="name" :width-auto="widthAuto"
                :no-data-text="noDataText"
                @click:item="onItemClick">

      <!-- Dati prodotti -->
      <template slot="items" slot-scope="{ item, index }">

        <!-- Immagine prodotto -->
        <td v-if="visibleColumns.includes('src')">
          <v-img :src="item.src || item.images[0].src" height="45px" class="my-2 mr-2" contain :aspect-ratio="1">
            <v-layout slot="placeholder" fill-height align-center justify-center>
              <v-icon slot="placeholder" color="accent" large absolute center>image</v-icon>
            </v-layout>
          </v-img>
        </td>

        <!-- Sku prodotto -->
        <td v-if="visibleColumns.includes('sku')">{{ item.sku }}</td>

        <!-- Nome prodotto -->
        <td v-if="visibleColumns.includes('name')">{{ item.name }}</td>

        <!-- Prezzo prodotto -->
        <td v-if="visibleColumns.includes('price')" class="text-xs-right">{{ item.price }}€</td>

        <!-- Prezzo di acquisto prodotto -->
        <td v-if="visibleColumns.includes('price_costumer')" class="text-xs-right">{{ item.price_costumer }}€</td>

        <!-- Quantità prodotto -->
        <td v-if="visibleColumns.includes('quantita') && !item.quantitaEditable" class="text-xs-right">
          {{ item.attivo !== false ? item.quantita : '-' }}
        </td>

        <!-- Quantità esterna prodotto -->
        <td v-if="visibleColumns.includes('quantitaEsterna') && !item.quantitaEditable" class="text-xs-right">
          {{ item.attivo !== false ? item.quantita_esterna : '-' }}
        </td>

        <!-- Quantità prodotto modificabile -->
        <td v-if="visibleColumns.includes('quantita') && item.quantitaEditable" class="text-xs-right">
          <number-input v-model.number="item.quantita" :max="item.quantitaMax"/>
        </td>

        <!-- Bottone aggiungi -->
        <td v-if="visibleColumns.includes('addable')">
          <slot name="btn-add" :item="item" :index="index">
            <v-btn color="accent" icon small flat class="right my-0" @click.stop="onAddClick(item, index)">
              <v-icon>add</v-icon>
            </v-btn>
          </slot>
        </td>

        <!-- Bottone rimuovi -->
        <td v-if="visibleColumns.includes('removable')">
          <slot v-if="item.attivo !== false && !$store.getters.isAbbonamentoExpired" name="btn-remove" :item="item" :index="index">
            <v-btn icon small flat class="right my-0" @click.stop="onRemoveClick(item, index)">
              <v-icon>clear</v-icon>
            </v-btn>
          </slot>
        </td>

      </template>

      <!-- Footer -->
      <template slot="footer">
        <slot name="footer"/>
      </template>

    </data-table>

    <product-dialog ref="productDialog"
                    v-bind="productDialogProps"
                    @re-enabled="$emit('re-enabled')"
                    @quantita-changed="$emit('quantita-changed')"/>

  </main>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import ProductDialog from '@/components/ProductDialog'
import { CategorieProdottiSelect } from '@/components/inputs'
import NumberInput from '@/components/inputs/NumberInput'

export default {
    name: 'ProductsDataTable',
    components: { NumberInput, DataTable, ProductDialog, CategorieProdottiSelect },
    props: {
        headers: {
            type: Array,
            default: () => []
            //  Valori accettabili: image, name, price, quantita, removable, addable
        },
        prodotti: {
            type: Array,
            default: () => []
        },
        category: {
            type: Number,
            default: null
        },
        rowsPerPage: {
            type: Number,
            default: -1
        },
        loading: Boolean,
        title: String,
        showFilters: Boolean,
        noDataText: String,
        widthAuto: Boolean,
        disableInfoDialog: Boolean,
        showDismessi: Boolean,
        disableClearableCategory: Boolean,
        productDialogProps: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            internalCategory: this.category,
            search: ''
        }
    },
    watch: {
        category (val) {
            this.internalCategory = val
        },
        internalCategory (val) {
            this.$emit('update:category', val)
        }
    },
    computed: {
        visibleColumns () {
            return this.headers.reduce((array, item) => array.concat(item.value), [])
        },
        filteredProdotti () {
            //  Se non è impostata nessuna categoria o sto mostrando i prodotti dismassi, non applico nessun filtro
            if (!this.internalCategory || this.internalCategory === -1) return this.prodotti
            return this.prodotti.filter(val => val.category.findIndex(item => item.id === this.internalCategory) !== -1, this)
        }
    },
    methods: {
        onItemClick (prodotto) {
            if (!this.disableInfoDialog) this.$refs.productDialog.show(prodotto)
        },
        onAddClick (prodotto) {
            this.$emit('click:add', prodotto, this.prodotti.indexOf(prodotto))
        },
        onRemoveClick (prodotto) {
            this.$emit('click:remove', prodotto, this.prodotti.indexOf(prodotto))
        }
    }
}
</script>
